import {Component, OnInit, ViewChild} from '@angular/core';
import feather from "feather-icons";
import {HeaderService} from "../../../../services/header/header.service";
import {Router} from "@angular/router";
import {forkJoin, of} from "rxjs";
import {catchError, map, switchMap} from "rxjs/operators";

import {EditWarehouseComponent} from "./edit-warehouse/edit-warehouse.component";
import {ResetStockComponent} from "./reset-stock/reset-stock.component";
import {HttpClient} from "@angular/common/http";
import {WarehouseService} from "../../../../services/warehouse/warehouse.service";
import {StockService} from "../../../../services/stock/stock.service";
import {ProductsService} from "../../../../services/products/products.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-gestion-stock',
  templateUrl: './gestion-stock.component.html',
  styleUrls: ['./gestion-stock.component.scss']
})
export class GestionStockComponent implements OnInit {

    @ViewChild('editWarehouse') editWarehouseComponent!: EditWarehouseComponent;
    @ViewChild('resetStock') resetStockComponent!: ResetStockComponent;
    currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
    userId = this.currentUser?.id;
    stationId = this.currentUser?.stations?.[0]?.id;
    showEdit = false;
    selectedWarehouse: any = null;
    warehouses: any[] = [];

    public contentHeader: object
    rotationDeg = 30; // Rotate 180°

  constructor(private headerService: HeaderService,
              private router : Router,
              private http: HttpClient,
              private warehouseService : WarehouseService,
              private stockService: StockService,
              private productsService: ProductsService,
              private toastr: ToastrService) { }
  ngAfterViewInit(): void {
    feather.replace();
  }
  ngOnInit(): void {

      this.getAllEntrepots();
      this.headerService.setConfig({
          title: 'Gestion de stock',
          buttons: [
              {
                  label: '+ Ajouter',
                  action: () => this.openAjoutModal(),
                  type: 'primary'
              }

          ]
      });
  }
    onWarehouseSaved() {
        //console.log('Warehouse saved, refreshing list...');
        this.getAllEntrepots(); // Reload the warehouses list
      //  this.toastr.success('Liste des entrepôts mise à jour');
    }
    onClick(warehouseId: number) {

        this.router.navigate(['stock/etat'], {
            queryParams: { entrepot_id: warehouseId }
        });

        // OR if you want it as route parameter:
        // this.router.navigate(['stock/etat', warehouseId]);

    }
    openAjoutModal() {
        this.editWarehouseComponent.warehouseData = null;
        this.editWarehouseComponent.openModal();
    }
    openEditModal(warehouse: any) {
        //console.log('Warehouse data before opening modal:', warehouse);
        // Check if code_postal exists in the data
        //console.log('Code postal value:', warehouse.code_postal);

      this.editWarehouseComponent.warehouseData = warehouse;
        this.editWarehouseComponent.openModal();
    }

    openResetModal(warehouseId: number) {
        this.resetStockComponent.entrepotId = warehouseId;
        this.resetStockComponent.openModal();
    }

    onStockReset() {
        this.getAllEntrepots();
    }


    updateWarehouse(updatedData: any) {
        this.warehouses = { ...updatedData };
        this.selectedWarehouse = null;
    }

    getAllEntrepots(): void {
        this.warehouseService.getAllWarehouses(this.userId, this.stationId).subscribe({
            next: (warehouses) => {
                this.warehouses = warehouses;
                this.loadStockValueByWarehouse();
            },
            error: (err) => console.error(err)
        });
    }

    /**
     * Pour chaque entrepôt : GET /api/stock/entrepot/:id → stocks, puis pour chaque product_id GET /api/products/:id (prix_unitaires) et somme (quantity * prix) en TND.
     */
    loadStockValueByWarehouse(): void {
        if (!this.warehouses?.length) return;
        forkJoin(
            this.warehouses.map((wh: any) =>
                this.stockService.getStockByEntrepot(wh.id).pipe(
                    switchMap((res) => {
                        const stocks = res?.data?.stocks || [];
                        if (stocks.length === 0) {
                            wh.stockValue = 0;
                            return of(0);
                        }
                        return forkJoin(
                            stocks.map((s: any) => {
                                const productId = s.product?.product_id ?? s.product_id;
                                const qty = parseFloat(s.quantity) || 0;
                                if (!productId) return of(0);
                                return this.productsService.getDetailsProduct(productId).pipe(
                                    map((res: any) => {
                                        const p = res?.data ?? res;
                                        const prix = Number(p?.prix_unitaires ?? p?.valeur_unitaire ?? p?.prix_achat ?? 0) || 0;
                                        return qty * prix;
                                    }),
                                    catchError(() => of(0))
                                );
                            })
                        ).pipe(
                            map((values: number[]) => {
                                const total = values.reduce((a, b) => a + b, 0);
                                wh.stockValue = Number(total.toFixed(3));
                                return total;
                            })
                        );
                    }),
                    catchError(() => {
                        wh.stockValue = null;
                        return of(null);
                    })
                )
            )
        ).subscribe();
    }
}
